/**
 * Created by liujintao on 18/2/28.
 */
 //埋点统计通用方法
var bury = function(action, obj){
  window.sa.track(action, obj);
}

/*序列串转为json*/
import {document,localStorage} from './hack-env';
import md5 from 'md5'
var compare = function(obj){
  let arr = [];

  for(let key in obj){
    let o = {};

    o[key] = obj[key];
    arr.push(o);
  }

  console.log(arr);
}

var serializerToJson = function(serializerString){
  var keyMapsArray=serializerString.split("&");
  var json={};
  keyMapsArray&&keyMapsArray.forEach(function(keyMap){
    var key_value=keyMap.split("=");
    if(json[key_value[0]]&&(Object.prototype.toString.call(json[key_value[0]]).toLowerCase()!='[object array]')){
      json[key_value[0]]=[json[key_value[0]]];
      json[key_value[0]].push(decodeURIComponent(key_value[1]));
    }else if(json[key_value[0]]&&(Object.prototype.toString.call(json[key_value[0]]).toLowerCase()==='[object array]')){
      json[key_value[0]].push(decodeURIComponent(key_value[1]));
    }else{
      json[key_value[0]]=decodeURIComponent(key_value[1]);
    }
  });
  return json;
};
var jsonToSerializer=function(json){
  var keys = Object.keys(json);
  var result = "";
  for(var i=0;i<keys.length;i++){
    if(i==0){
      result+=keys[i]+'='+encodeURIComponent(json[keys[i]]);
    }else if(i==keys.length-1){
      result+='&'+keys[i]+'='+encodeURIComponent(json[keys[i]]);
    }else if(keys[i]){
      result+='&'+keys[i]+'='+encodeURIComponent(json[keys[i]]);
    }
  }
  return result;
};
var getUrlQueryObject = function(){
  var url = location.href;
  var hash;
  //去掉hash
  if(url.indexOf('#') > -1){
    hash = location.hash.substring(location.hash.indexOf('#'),location.hash.indexOf('?'));
    url = url.replace(hash,"");
  }
  var paraString = url.substring(url.indexOf("?") + 1, url.length).replace(/\?/g,'&').split("&");
  var paraObj = {}
  for (var i = 0,j;j = paraString[i]; i++) {
    paraObj[j.substring(0, j.indexOf("=")).toLowerCase()] = j.substring(j.indexOf("=") + 1, j.length);
  }
  return paraObj;
}
/*获取URL中的参数*/
var getUrlParameter = function (name, targetUrl){
  var url = targetUrl || location.href;
  var paraString = url.substring(url.indexOf("?") + 1, url.length).replace(/\?/g,'&').split("&");
  var paraObj = {}
  for (var i = 0,j;j = paraString[i]; i++) {
    paraObj[j.substring(0, j.indexOf("=")).toLowerCase()] = j.substring(j.indexOf("=") + 1, j.length);
  }
  var returnValue = paraObj[name.toLowerCase()];
  if (typeof (returnValue) == "undefined") {
    return "";
  } else {
    return decodeURIComponent(returnValue);
  }
};
//去除左右空格
var trim=function(str){
  if (typeof str === "string") {
    return str.replace(/(^\s\s*)/, "").replace(/\s\s*$/, "");
  }
  return str;
};
//检测移动设备
var checkMobile = function(){
  var ua = navigator.userAgent;ua = ua ? ua.toLowerCase().replace(/-/g, "") : "";
  if (ua.match(/(Android)/i)){return "android";}
  if (ua.match(/(iPhone|iPod)/i)){return "iphone";}
  if (ua.match(/(iPad)/i)){return "ipad";}
  if (ua.match(/(Windows Phone)/i)){return "windows phone"}//windows phone
  if (ua.match(/(Symbian)/i)){return "symbian"}//塞班
  if (ua.match(/(Nokia)/i)){return "nokia"}//塞班
  if (ua.match(/(PlayBook)/i)){return "playbook"}//黑莓playbook
  if (ua.match(/(BB)/i)){return "blackberry"}//黑莓
  if (ua.match(/(KFAPWI)/i)){return "kindlefire"}//kindle
  //UC Browser
  if (ua.match(/(U;)/i)){if (ua.match(/(Adr)/i)){return "android";}}
  if (ua.match(/(U;)/i)){if (ua.match(/(iPh)/i)){return "iphone";}}
  if (ua.match(/(U;)/i)){if (ua.match(/(iPd)/i)){return "ipad";}}
  return "";
};
var cookie = {
  /**
   * 设置一个cookie
   *
   * @param {String}
   *          name cookie名称
   * @param {String}
   *          value cookie值
   * @param {String}
   *          domain 所在域名 默认为window.location.host的值
   * @param {String}
   *          path 所在路径 默认为是"\"
   * @param {Number}
   *          hour 存活时间，单位:小时
   * @return {Boolean} 是否成功
   */
  set: function(name, value, domain, path, hour) {
    if (hour) {
      var today = new Date();
      var expire = new Date();
      expire.setTime(today.getTime() + 3600000 * hour);
    }
    var ar = name + "=" + value + "; " + (hour ? ("expires=" + expire.toGMTString() + "; ") : "") + (path ? ("path=" + path + "; ") : "path=/; ") + (domain ? ("domain=" + domain + ";") : ("domain=" + location.host + ";"));
    document.cookie = name + "=" + value + "; " + (hour ? ("expires=" + expire.toGMTString() + "; ") : "") + (path ? ("path=" + path + "; ") : "path=/; ") + (domain ? ("domain=" + domain + ";") : ("domain=" + location.host + ";"));
    return true;
  },

  /**
   * 获取指定名称的cookie值
   *
   * @param {String}
   *          name cookie名称
   * @return {String} 获取到的cookie值
   */
  get: function(name,cookie) {
    var r = new RegExp("(?:^|;+|\\s+)" + name + "=([^;]*)");
    var m = cookie?cookie.match(r):document.cookie.match(r);
    return (!m ? "" : m[1]);
  },

  /**
   * 删除指定cookie,复写为过期
   *
   * @param {String}
   *          name cookie名称
   * @param {String}
   *          domain 所在域 默认为 window.location.host的值
   * @param {String}
   *          path 所在路径 默认为是"\"
   */
  del: function(name, domain, path) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    document.cookie = name + "=; expires=" + exp.toGMTString() + ";" + (path ? ("path=" + path + "; ") : "path=/; ") + (domain ? ("domain=" + domain + ";") : ("domain=" + location.host + ";"));
  }
}
var log = function(messsage,style){
  console.log("%c " + messsage,style||'color:red;font-size:1.5rem;');
}
var formatDate = function(date, fmt) {
  var o = {
      "y+" : date.getFullYear(),                 //年
      "M+" : date.getMonth()+1,                 //月份
      "d+" : date.getDate(),                    //日
      "h+" : date.getHours(),                   //小时
      "m+" : date.getMinutes(),                 //分
      "s+" : date.getSeconds(),                 //秒
      "q+" : Math.floor((date.getMonth()+3)/3), //季度
      "S"  : date.getMilliseconds()             //毫秒
  }

  if(/(y+)/.test(fmt))
      fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
      if(new RegExp("("+ k +")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
  return fmt;
};
var compareAppVersion = function(base,nowVersion){
  var base = base.split('.');
  var now = nowVersion.split('.');
  var moreThan = true;
  for(var i=0;i<base.length;i++){
    var nowNum = parseInt(now[i]);
    var baseNum = parseInt(base[i]);
    if(nowNum>baseNum){
      moreThan = true;
      break;
    }
    else if(nowNum<baseNum){
      moreThan = false;
      break;
    }
  }
  return moreThan;
};
var loadScript = function(url,callback){
  if(!url){
    throw new Error('缺少脚本文件url');
  }
  var id = md5(url);
  var script = document.createElement("script");
  script.src = url;
  script.id = id;
  if(!document.getElementById(id)){
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(script, s);
    script.onload = callback;
  }else{
    callback&&callback();
  }
}
var loadStyle = function(url,callback){
  if(!url){
    throw new Error('缺少样式文件url');
  }
  var id = md5(url);
  var style = document.createElement("link");
  style.href = url;
  style.id = id;
  style.rel="stylesheet";
  style.type = 'text/css';
  if(!document.getElementById(id)){
    var s = document.getElementsByTagName("head")[0];
    s.appendChild(style);
    style.onload = callback;
  }else{
    callback&&callback();
  }
}
var unloadStyle = function(url,callback){
    if(!url){
      throw new Error('缺少样式文件url');
    }
    var id = md5(url);

    if(document.getElementById(id)){
      document.getElementById(id).remove();
      callback&&callback();
    }else{
      callback&&callback();
    }
  }
  var unloadScript = function(url,callback){
    if(!url){
      throw new Error('缺少样式文件url');
    }
    var id = md5(url);

    if(document.getElementById(id)){
      document.getElementById(id).remove();
      callback&&callback();
    }else{
      callback&&callback();
    }
  }

/**
 * 判断是否支持webp
 */
var isSupportWebp = function(){
  try {
    return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0;
  } catch(err) {
    return false;
  }
}
  /**
   *
   * @param {String} url 图片地址
   * @param {Object} options 处理信息
   * @param {Number} options.cw 剪切的宽度
   * @param {Number} options.ch 剪切的高度
   * @param {Number} options.w 缩放的宽度
   * @param {Number} options.h 缩放的高度
   */
 var imageMogr2 = function(url, options) {
    var resurl = `${url}?imageMogr2/thumbnail/${options.w || ''}x${options.h || ''}`
    if (options.cw || options.ch) {
      resurl = `${resurl}/crop/${options.cw || ''}x${options.ch || ''}`
    }
    if(options.q){
      resurl = `${resurl}/quality/${options.q}`
    }
    if(isSupportWebp()){
      resurl = `${resurl}/format/webp`;
    }
    return resurl
}  
var utils = {
  serializerToJson:serializerToJson,
  jsonToSerializer:jsonToSerializer,
  getUrlQueryObject:getUrlQueryObject,
  getParameter:getUrlParameter,
  trim:trim,
  checkMobile:checkMobile,
  cookie:cookie,
  log:log,
  bury: bury,
  formatDate:formatDate,
  compareAppVersion:compareAppVersion,
  loadScript:loadScript,
  loadStyle:loadStyle,
  unloadStyle:unloadStyle,
  unloadScript:unloadScript,
  imageMogr2:imageMogr2
}
if(process.env.VUE_ENV!='server'){
  window.utils = utils;
}
export default utils;



// WEBPACK FOOTER //
// ./src/common/libs/utils.js